module.exports = __webpack_public_path__ + "static/img/作品81.819c88a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品81.png
// module id = glBX
// module chunks = 1